import useDialog from './hooks/useDialog'
import Typography from '@mui/material/Typography'
import Dialog from '../control/Dialog'
import Button from '../control/Button'

type DialogPlaygroundType = ReturnType<typeof useDialog>

const DialogPlaygroundView = (props: DialogPlaygroundType) => {
    const {
        openDialog,
        onOpen,
        onClose,
        openDialogConfirm,
        onOpenConfirm,
        onConfirm,
        onCancel,
        openDialogOk,
        onOpenOk,
        onOk,
    } = props

    return (
        <div>
            <Typography variant="h3" gutterBottom>
                Control: Dialog
            </Typography>
            <Button onClick={onOpen}>Open dialog</Button>
            <Dialog isOpen={openDialog} onClose={onClose} title={'Title'}>
                <Typography gutterBottom>
                    Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas
                    eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                </Typography>
                <Typography gutterBottom>
                    Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue
                    laoreet rutrum faucibus dolor auctor.
                </Typography>
                <Typography gutterBottom>
                    Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                </Typography>
            </Dialog>
            <br />
            <br />
            <Button onClick={onOpenConfirm}>Open dialog (Confirm)</Button>
            <Dialog
                type="confirm"
                title={'Title (Confirm)'}
                isOpen={openDialogConfirm}
                onClickConfirm={onConfirm}
                onClickCancel={onCancel}
                disableClickBackdrop
                hideCloseButton
            >
                <Typography gutterBottom>
                    Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas
                    eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                </Typography>
            </Dialog>
            <br />
            <br />
            <Button onClick={onOpenOk}>Open dialog (OK)</Button>
            <Dialog type="ok" title={'Title (OK)'} isOpen={openDialogOk} onClickOk={onOk}>
                <Typography gutterBottom>
                    Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas
                    eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                </Typography>
            </Dialog>
        </div>
    )
}

//Controller
const DialogPlayground = () => {
    const dialogModel = useDialog()
    return <DialogPlaygroundView {...dialogModel} />
}

export default DialogPlayground
